import React, { useEffect, useState } from 'react';
import { Grid, Button } from '@material-ui/core';

import { useStyles } from './styles';
import { IFilters } from './interfaces';
import { Can } from 'components/util/Can';
import { useEnvironment, useSnackbar } from 'hooks';
import { Autocomplete, IOptions } from 'components/migrated/autocomplete';
import { useSuppliersGql } from 'pages/quality/productReturn/graphql/suppliers';

export const Filters = (props: IFilters) => {
  const { onChange } = props;
  const { runSuppliersGql, dataSuppliers, errorSuppliers, loadingSuppliers } = useSuppliersGql();
  const { DEBUG } = useEnvironment();
  const { Snackbar, toggleSnackbar } = useSnackbar();
  const classes = useStyles();
  const [supplierId, setSupplierId] = useState(0);

  const handleOnChange = (options: IOptions) => setSupplierId(+options?.key);

  const handleOnClick = (idFornecedor: number) => {
    onChange(idFornecedor);
  };

  useEffect(() => {
    runSuppliersGql();
  }, []);

  useEffect(() => {
    if (errorSuppliers) {
      if (DEBUG === 'TRUE') {
        console.log(`Erro ao carregar dados! Error:(message: ${errorSuppliers} )`);
      } else {
        toggleSnackbar({
          message: 'Ocorreu um problema ao carregar os fornecedores. Por favor, informe ao suporte.',
          type: 'error'
        });
      }
    }
  }, [errorSuppliers]);

  return (
    <Can permissions={['filtro-fornecedor']}>
      <Snackbar />
      <div className={classes.root}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Autocomplete
              showObjectKey
              objects={dataSuppliers}
              objectKey="personId"
              objectValue="supplierName"
              onChange={handleOnChange}
              label="Selecione o fornecedor"
              defaultValue={''}
              loading={loadingSuppliers}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6}>
            <div className={classes.buttonPosition}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => handleOnClick(supplierId)}
                className={classes.aplicar}
              >
                APLICAR
              </Button>
            </div>
          </Grid>
        </Grid>
      </div>
    </Can>
  );
};
